import {
  ChartNoDataContainer,
  ErrorStateHeader,
  ErrorStateSubtext,
  NoDataWrapper,
} from 'components/ErrorStates/ChartErrorStates/ChartErrorStates.styled';
import { NoDataLighthouse } from 'components/ErrorStates/ErrorStateSvg/NoDataLighthouse';

const ChartNoDataScreen = () => {
  return (
    <ChartNoDataContainer data-testid="no-data-container">
      <NoDataWrapper>
        <NoDataLighthouse />
        <ErrorStateHeader>No data to show</ErrorStateHeader>
        <ErrorStateSubtext>
          This site does not return any data for the selected date.{' '}
        </ErrorStateSubtext>
        <ErrorStateSubtext>
          Please select another site or another date.
        </ErrorStateSubtext>
      </NoDataWrapper>
    </ChartNoDataContainer>
  );
};

export default ChartNoDataScreen;
